/** @jsx jsx */
import { jsx } from '@emotion/react';
import Button from 'react-bootstrap/lib/Button';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import { Link } from 'react-router';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import omit from 'lodash/omit';
import keys from 'lodash/keys';

import { Flex } from '../flex';
import Preloader from '../preloader/preloader';
import propTypes from './button.proptypes';
import { buttonCss, labelCss, preloaderCss } from './button.css';

const propKeys = keys(propTypes);

const CommonButton = ({
  blocklevel,
  children,
  dropdown,
  id,
  preloaderColor,
  showPreloader,
  to,
  tooltip,
  tooltipId,
  tooltipPlacement,
  ...rest
}) => {
  const componentClass = to ? Link : undefined;
  const isDisabled = rest.disabled || showPreloader;
  const isDropdown = dropdown && !isDisabled;
  const Element = isDropdown ? DropdownButton : Button;

  const element = (
    <Element
      css={buttonCss(rest)}
      componentClass={componentClass}
      {...omit(rest, propKeys)}
      disabled={isDisabled}
      id={id}
      to={to}
    >
      {isDropdown ? (
        children
      ) : (
        <span css={labelCss(showPreloader)}>{dropdown ? rest.title : children}</span>
      )}

      {showPreloader && (
        <Flex css={preloaderCss} alignItems="center" justifyContent="center">
          <Preloader color={preloaderColor} />
        </Flex>
      )}
    </Element>
  );
  return tooltip && !isDisabled ? (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={<Tooltip id={tooltipId}>{tooltip}</Tooltip>}
    >
      {element}
    </OverlayTrigger>
  ) : (
    element
  );
};

CommonButton.propTypes = propTypes;
CommonButton.defaultProps = { tooltipPlacement: 'bottom' };

export default CommonButton;
